$(document).ready(function($) {

    if (typeof Editor != "undefined") {
        App.loadFonts();
        return;
    }
    initRecaptcha();
    App.init();
    Page.init($('body'));
    // FormatNumbers.init();
    // Popup.init();

    // if (window.location.href.replace(WEB_ROOT + "/", "") != "") {
    //   $('[component="header"]').attr("scrolled", "");
    //   $('[component="directory"]').attr("scrolled", "");
    // }

    Promise.all([
    // App.winLoaded(),
    // Directory.loadPages($('[component="directory"]'))
    // App.loadFonts()
    ]).then(function() {
        if (App.debug) {
            console.log("****************** all loaded **************************");
        }
        // Scroller.init();
        Router.init();
        Header.init(200);
        // Homepage.init();
        setTimeout(function() {
            App.show();
        }, 1);
        Directory.wasLoaded = true;

        setTimeout(function() {
            if (!Router.subpage && App.hasDirectory) Directory.closePage();
        }, 800);
    });

});


App = {
    debug: false,
    hasDirectory: false,
    el: {},

    init: function() {
        this.el = $("<body>");
    // this.initVideo();
    },

    loadFonts: function() {
        return new Promise(function(resolve, reject) {
            try {
                Typekit.load({
                    async: true,
                    active: resolve
                });
            } catch (e) {
                resolve();
            }
        });
    },

    winLoaded: function() {
        return new Promise(function(resolve, reject) {
            $(window).load(resolve);
        });
    },

    initVideo: function() {
        var videoCover = $("<video-cover/>");
        videoCover.appendTo("body");

        var video = $(
            '<video id="video" poster="preview-file/video-poster.jpg" playsinline muted loop></video>'
            );
        var source = "";

        if (window.matchMedia("(min-width: 1300px)").matches) {
            source = $(
                '<source src="' +
                WEB_ROOT +
                '/files/31116190-preview.mp4" type="video/mp4">'
                );
        } else if (window.matchMedia("(min-width: 980px)").matches) {
            source = $(
                '<source src="' +
                WEB_ROOT +
                '/files/31116190-preview.mp4" type="video/mp4">'
                );
        } else {
            source = $(
                '<source src="' +
                WEB_ROOT +
                '/files/31116190-preview.mp4" type="video/mp4">'
                );
        }
        source.appendTo(video);
        video.appendTo("body");
        video[0].play();
    },

    show: function() {
        this.el.removeAttr("before-show").attr("show", "");
        $("[component]").removeAttr("before-show").attr("show", "");
        $('[component="page"] content').attr("state", "show");
        $("[page]").removeAttr("before-show").attr("show", "");

        /*TODO
        iný spôsob vymyslieť ako zapnúť READY state
        aktuálne slúži na vypínanie transition-delay, ktorá je v READY state neželaná*/

        setTimeout(function() {
            App.el.removeAttr("show").attr("ready", "");
            $("[component]").removeAttr("show").attr("ready", "");
            $('[component="page"] content').attr("state", "ready");
            $("[page]").removeAttr("show").attr("ready", "");
        }, 1500);
    }
};

FormatNumbers = {
    init: function() {
        accounting.settings = {
            currency: {
                symbol: "€", // default currency symbol is '$'
                format: "%v %s", // controls output: %s = symbol, %v = value/number (can be object: see below)
                decimal: ",", // decimal point separator
                thousand: " ", // thousands separator
                precision: 2 // decimal places
                },
                number: {
                precision: 2, // default precision on numbers is 0
                thousand: " ",
                decimal: ","
            }
        };
    }
};

// Scroll = {
//     init: function(collection) {
//         $("[scrollable]", collection || $("body")).overlayScrollbars({
//             className: "os-theme-dark"
//         });
//     }
// };

Keyboard = {
    binded: false,

    init: function(collection) {
        var elm = $('[data-method="getSliderRemote"]', collection || $("body"));
        if (!elm.length) return;

        this.el = elm;

        if (!this.binded) this.binded = true;
        else return;

        $(document).keydown(function(e) {
            // console.log(e.which, Keyboard.el);
            if (e.which == 37) {
                Keyboard.el.find(".prev").trigger("click");
            }

            if (e.which == 39) {
                Keyboard.el.find(".next").trigger("click");
            }

            if (e.which == 27) {
                Keyboard.el.find(".close").trigger("click");
            }
        });
    }
};

ProfileButton = {
    init: function(collection) {
        this.button = $('.button.expander', collection || $("body"));
        if (!this.button) return;

        this.button.click(function(event) {
            event.preventDefault();
            if ($(this).is('.expanded')) {
                ProfileButton.collapse($(this));
            } else {
                ProfileButton.expand($(this));
            }
            
        });
    },

    expand: function(button) {
        button.addClass('expanded');
        button.prev('.expander-content').slideDown('500')
    },

    collapse: function(button) {
        button.removeClass('expanded');
        button.prev('.expander-content').slideUp('500');
    }
};


Porfolio = {
    init: function(collection) {
        this.el = $('[page="portfolio"], [page="home"], [page="subpage"]', collection || $("body"));
        if (!this.el.length) return;
        this.bind();
    },

    bind: function(button) {
       this.el.find('[block="squares"] a').attr('direction', 'open');
       this.el.find('[block="squares"] .menu.squares a').attr('direction', 'next');
    },
};

